import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, nextTick } from 'vue'
import type { ApexOptions } from 'apexcharts'

interface Props {
  data?: number[]
  categories?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ThisWeekChart',
  props: {
    data: { default: () => [] },
    categories: { default: () => [] }
  },
  setup(__props: any) {

const props = __props

const chartReady = ref(false)

onMounted(async () => {
  await nextTick()
  chartReady.value = true
})

const revenue = computed(() => [
  {
    name: "Count",
    data: props.data,
  },
])

const revenueChart = computed<ApexOptions>(() => ({
  chart: {
    animations: {
      enabled: true,
      dynamicAnimation: {
        enabled: true,
        speed: 350
      }
    },
    redrawOnParentResize: true,
    redrawOnWindowResize: true,
    height: 300,
    type: "line",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  colors: ["#5C61F2"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
  },
  markers: {
    size: [7],
  },
  grid: {
    borderColor: "rgba(92, 97, 242, 0.25)",
    row: {
      colors: ["#F4F6FA", "transparent"],
      opacity: 1,
    },
  },
  xaxis: {
    categories: props.categories,
    labels: {
      style: {
        colors: [
          "#919AA3",
          "#919AA3",
          "#919AA3",
          "#919AA3",
          "#919AA3",
          "#919AA3",
          "#919AA3",
        ],
      },
    },
  },
  yaxis: {
    labels: {
      formatter: (val: number) => {
        return "" + val / 1
      },
      style: {
        colors: [
          "#A9A9C8",
          "#A9A9C8",
          "#A9A9C8",
          "#A9A9C8",
          "#A9A9C8",
          "#A9A9C8",
          "#A9A9C8",
        ],
      },
    },
  },
}))

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock(_component_apexchart, {
    type: "line",
    height: "300",
    options: revenueChart.value,
    series: revenue.value
  }, null, 8, ["options", "series"]))
}
}

})